export const ONBOARDING_SIDE_NAV_STATE_KEYS = {
	MIGRATE_SHORTCUTS_CHANGEBOARDING_SEEN: 'onboarding-side-nav:migrateShortcutsChangeBoardingSeen',
};
